import { render, staticRenderFns } from "./SpuManage.vue?vue&type=template&id=9c248b80&scoped=true"
import script from "./SpuManage.vue?vue&type=script&lang=js"
export * from "./SpuManage.vue?vue&type=script&lang=js"
import style0 from "./SpuManage.vue?vue&type=style&index=0&id=9c248b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c248b80",
  null
  
)

/* custom blocks */
import block0 from "./SpuManage.vue?vue&type=custom&index=0&blockType=el-table-column&label=%E5%93%81%E7%89%8C%E4%BF%A1%E6%81%AF&width=120"
if (typeof block0 === 'function') block0(component)
import block1 from "./SpuManage.vue?vue&type=custom&index=1&blockType=el-table-column&prop=color&label=%E9%A2%9C%E8%89%B2&width=100"
if (typeof block1 === 'function') block1(component)
import block2 from "./SpuManage.vue?vue&type=custom&index=2&blockType=el-table-column&prop=size&label=%E5%B0%BA%E7%A0%81&width=100"
if (typeof block2 === 'function') block2(component)
import block3 from "./SpuManage.vue?vue&type=custom&index=3&blockType=el-table-column&label=%E6%80%BB%E5%BA%93%E5%AD%98&width=100"
if (typeof block3 === 'function') block3(component)
import block4 from "./SpuManage.vue?vue&type=custom&index=4&blockType=el-table-column&label=%E6%93%8D%E4%BD%9C&width=250"
if (typeof block4 === 'function') block4(component)
import block5 from "./SpuManage.vue?vue&type=custom&index=5&blockType=el-pagination&class=pagination&%40size-change=handleSizeChange&%40current-change=handleCurrentChange&%3Acurrent-page=query.pageNum&%3Apage-sizes=%5B10%2C%2020%2C%2050%2C%20100%5D&%3Apage-size=query.pageSize&layout=total%2C%20sizes%2C%20prev%2C%20pager%2C%20next%2C%20jumper&%3Atotal=total"
if (typeof block5 === 'function') block5(component)
import block6 from "./SpuManage.vue?vue&type=custom&index=6&blockType=el-dialog&%3Atitle=spuDialogTitle&%3Avisible.sync=spuDialogVisible&width=600px"
if (typeof block6 === 'function') block6(component)

export default component.exports